const pagePickerStyles = theme => ({
    paperDialog: {
        display: 'flex',
        margin: theme.spacing.unit * 4,
        flexDirection: 'column',
        flex: '0 1 auto',
        position: 'relative',
        maxHeight: '90vh',
        overflowY: 'auto',
        backgroundColor: '#eeeeee',
        '&:focus': {
            outline: 'none',
        },
    },
    fullWidth: {
        width: '80%'
    },
    pagePickerDialogContent: {
        marginLeft: 10
    },
    pagesSearchResults: {
        width: '100%',
        marginTop: 10,
    },
    pagesSearchResultsItems: {
        padding: 10,
    },
    headingPageSearch: {
        display: 'inline-flex',
    },
    loadingText: {
        textAlign: 'center',
        fontSize: '1.2em',
        color: '#666',
        margin: '15px 0'
    },
    buttons: {
        margin: '0 8px 8px 0'
    },
});

export default pagePickerStyles;


// WEBPACK FOOTER //
// ./src/containers/page-picker/style.js